import { render, staticRenderFns } from "./FilterContactType.vue?vue&type=template&id=872c22ee&scoped=true&lang=pug"
import script from "./FilterContactType.vue?vue&type=script&lang=js"
export * from "./FilterContactType.vue?vue&type=script&lang=js"
import style0 from "./FilterContactType.vue?vue&type=style&index=0&id=872c22ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c22ee",
  null
  
)

export default component.exports